import { MAIN_STYLE, MAIN_STYLE_GROUPS, PRESS_EVENTS } from '../shared.js'
export const led = {

    parts: {
        main: {
            label: 'Main',
            exportSuffix: '',
            order: 0,
            propertyGroups: [...MAIN_STYLE_GROUPS],
            properties: {
                ...MAIN_STYLE,
                // LED's actual "glow" mechanism (lv_led.c:207-218) — mixed toward black and
                // scaled by brightness, not decorative extras. Real theme defaults below
                // (lv_theme_hasp.c:518-533).
                shadow_width:  { type: 'int', min: 0 },
                shadow_color:  { type: 'color' },
                shadow_spread: { type: 'int', min: 0 },
            },
        },
    },

    properties: {
        x: { type: 'int' }, y: { type: 'int' },
        width: { type: 'int', min: 0 }, height: { type: 'int', min: 0 },
        min_width: { type: 'int', min: 0 }, min_height: { type: 'int', min: 0 },
        haspid:   { type: 'int', min: 1, max: 254, internal: true },
        parentid: { type: 'int', min: 0, max: 254, internal: true },
        enabled: { type: 'bool' }, hidden: { type: 'bool' },
        val:     { type: 'int', min: 0, max: 255 },
        // attribute_common_range (hasp_attribute.cpp:2274-2341) has no LV_HASP_LED case —
        // LED's 0-255 range is hardcoded internally in firmware and used only for the
        // designer's own HA-value normalization; exporting led0.min/led0.max is a silently
        // ignored no-op on real firmware. Kept (not deleted) since HaspLed.js/HA-binding
        // normalization may still read this.min/this.max internally; marked internal so
        // they're no longer treated as real exported/editable wire attributes.
        min:     { type: 'int', internal: true },
        max:     { type: 'int', internal: true },
        groupid: { type: 'int', min: 0, max: 15, exportSpecial: true },
    },

    defaults: {
        properties: {
            x: 0, y: 0, width: 100, height: 100, min_width: 10, min_height: 10,
            enabled: true, hidden: false,
            val: 255, min: 0, max: 255,
        },
        styles: {
            // Matches firmware's real led_init() theme (lv_theme_hasp.c:518-533).
            // bg_color approximates theme.color_primary, which firmware derives at runtime
            // as lv_color_hsv_to_rgb(200, 100, 100) (hasp.cpp:84) — user-configurable via
            // haspThemeHue, so no single literal is truly "the" firmware default; this is a
            // reasonable placeholder matching the out-of-the-box hue, not a verified-fixed
            // value (same caveat as dropdown.js's scrollbar.bg_color placeholder).
            main: {
                bg_color: '#00aaff', border_width: 2, radius: 999,
                shadow_width: 15, shadow_color: '#00aaff', shadow_spread: 5,
            },
        },
    },
    states: ['pressed', 'disabled'],
    editorCapabilities:  ['can_transform', 'can_copy'],
    runtimeCapabilities: ['has_action', 'has_group', 'has_data'],

    events: PRESS_EVENTS,
    bindings: {
        properties: { val: {}, bg_color: {} },
        actions: { hass_services: ['', 'homeassistant', 'openhasp', 'light', 'switch', 'esphome'] },
        events: {},
    },
}
